export const partnersDashboard = '/partner-dashboard';
export const reports = 'reports';
export const settings = 'settings';
export const profile = 'profile';
